import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { UserX, Undo2, Plus } from "lucide-react";

const SOURCE = (s) => (s || "").startsWith("manual") ? "ręcznie" : "link w mailu";

export const UnsubscribesPanel = () => {
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const load = () => api.get("/campaigns/unsubscribes").then((r) => setList(r.data.unsubscribes)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!email.trim()) return;
    try { await api.post("/campaigns/unsubscribes", { email }); toast.success("Dodano do wypisanych"); setEmail(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Błąd"); }
  };
  const remove = async (em) => {
    try { await api.delete(`/campaigns/unsubscribes/${encodeURIComponent(em)}`); toast.success("Przywrócono do mailingów"); load(); }
    catch { toast.error("Błąd"); }
  };

  return (
    <section className="border border-border bg-white rounded-md p-5 mt-6" data-testid="unsubscribes-panel">
      <div className="flex items-center gap-2 flex-wrap mb-3">
        <UserX className="h-4 w-4 text-[#193962]" />
        <h3 className="font-[Outfit] font-semibold">Wypisani</h3>
        <span className="text-xs text-muted-foreground" data-testid="unsub-count">({list.length})</span>
        <div className="flex gap-2 ml-auto w-full sm:w-auto">
          <Input data-testid="unsub-email-input" placeholder="adres@firma.com" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} className="h-9 sm:w-64" />
          <Button size="sm" onClick={add} data-testid="unsub-add-btn" className="bg-[#193962] text-white h-9"><Plus className="h-3.5 w-3.5 mr-1" />Wypisz</Button>
        </div>
      </div>
      {list.length === 0 ? <p className="text-sm text-muted-foreground font-[Manrope]" data-testid="unsub-empty">Nikt jeszcze nie zrezygnował z mailingów.</p> : (
        <div className="divide-y divide-border max-h-80 overflow-auto">
          {list.map((u) => (
            <div key={u.email} className="flex items-center gap-3 py-2 text-sm" data-testid={`unsub-row-${u.email}`}>
              <div className="min-w-0 flex-1">
                <p className="font-medium truncate">{u.email}</p>
                <p className="text-[11px] text-zinc-500 truncate">
                  {u.client_id ? <Link to={`/clients/${u.client_id}`} className="underline">{u.company_name}</Link> : "spoza CRM"} · {SOURCE(u.source)} · {u.at ? new Date(u.at).toLocaleString("pl-PL") : ""}
                </p>
              </div>
              <Button size="sm" variant="ghost" onClick={() => remove(u.email)} data-testid={`unsub-remove-${u.email}`}><Undo2 className="h-3.5 w-3.5 mr-1" />Przywróć</Button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
